import { THEME } from '../config/commons';

export const getCurrentTheme = () => {
  const theme = localStorage.getItem('theme') as THEME;
  return theme || THEME.DARK;
};
